export default "__VITE_ASSET__78f51ff3__"